import React, {PropTypes} from 'react';

const MultiSelect = props => {
  let {options, selected, onChange} = props;
  let actives = {};
  selected.forEach(select => {
    actives[select] = true;
  });

  function handleClick(value, active) {
    if (!active) {
      delete actives[value];
    }
    else {
      actives[value] = true;
    }
    onChange(Object.keys(actives));
  }

  return (
    <div>
      {options.map(option => {
        let disabled = option.disabled || false;
        return (
          <div key={option.value} className="checkbox">
            <label><input type="checkbox" checked={!disabled && selected.indexOf(option.value) > -1} disabled={disabled} onChange={(event) => {
              handleClick(option.value, event.target.checked);
            }}/><span>{option.label}</span></label>
          </div>
        );
      })}
    </div>
  );
};

MultiSelect.propTypes = {
  options: PropTypes.array.isRequired,
  selected: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired
};

export default MultiSelect;



/** WEBPACK FOOTER **
 ** ./src/modules/ui/components/MultiSelect.js
 **/